<template>
  <div>
    <!-- Search -->
    <div class="bg-body-dark">
      <div class="content">
        <div class="pt-5">
          <h2 class="mb-2 text-center">
            {{$t('networkTransfers.home.transfersNetworkGraph')}}
          </h2>
          <h4 class="font-w300 text-muted push text-center">
          </h4>
        </div>
        <form v-on:submit.prevent="getResults()">
          <div class="form-group">
            <input v-model="search" type="text" class="form-control form-control-lg py-3 text-center" :placeholder="$t('networkTransfers.home.enterAccountHere')">
          </div>
          <div class="form-group row items-push mb-0 justify-content-center">
            <div class="col-sm-6 col-md-4">
              <button type="submit" class="btn btn-primary btn-block" :disabled="search === ''">{{$t('networkTransfers.home.search')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- END Search -->
    <div class="bg-body-light">
      <div class="content content-boxed content-full">
        <div class="row py-3">
          <div class="col-sm-6 col-md-4 mb-5 text-center">
            <div class="my-3">
              <i class="fa fa-2x fa-plus text-success"></i>
            </div>
            <h4 class="h5 mb-2">
              {{$t('networkTransfers.home.addRemoveAccounts')}}
            </h4>
            <p class="mb-0 text-muted">
              {{$t('networkTransfers.home.addRemoveAccountsDesc1')}} {{$t('networkTransfers.home.addRemoveAccountsDesc2')}}
            </p>
          </div>
          <div class="col-sm-6 col-md-4 mb-5 text-center">
            <div class="my-3">
              <i class="fa fa-2x fa-info text-info"></i>
            </div>
            <h4 class="h5 mb-2">
              {{$t('networkTransfers.home.transferDetails')}}
            </h4>
            <p class="mb-0 text-muted">
              {{$t('networkTransfers.home.transferDetailsDesc1')}} {{$t('networkTransfers.home.transferDetailsDesc1')}}
            </p>
          </div>
          <div class="col-sm-6 col-md-4 mb-5 text-center">
            <div class="my-3">
              <i class="fa fa-2x fa-filter text-xinspire"></i>
            </div>
            <h4 class="h5 mb-2">
              {{$t('networkTransfers.home.filtersAndSettings')}}
            </h4>
            <p class="mb-0 text-muted">
              {{$t('networkTransfers.home.filtersAndSettingsDesc1')}} {{$t('networkTransfers.home.filtersAndSettingsDesc2')}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    search: {
      // getter
      get () {
        return this.$store.state.filter.search
      },
      // setter
      set (value) {
        this.$store.commit('setSearch', value)
      }
    },
    filters () {
      return this.$store.state.filter.filters
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    getResults () {
      this.$store.dispatch('addAccounts', { accounts: this.search.split('-'), reset: true })
      this.$store.dispatch('loadNetworkGraphData').then(() => {
        this.$router.push({
          name: 'NetworkGraphNetwork',
          query: this.$store.getters.getRouteParams
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
